const STORAGE_PREFIX = "canutillo_drafts_";
const MAX_DRAFTS = 3;

export function getDrafts(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${userId}`);
    if (raw) {
      return JSON.parse(raw);
    }
  } catch (e) {
    console.error("Error reading drafts from localStorage", e);
  }
  return [];
}

export function saveDraft(userId, draftId, draftData) {
  if (!userId || !draftId) return;
  try {
    const drafts = getDrafts(userId);
    const existingIndex = drafts.findIndex((d) => d.id === draftId);
    
    const draftEntry = {
      id: draftId,
      updatedAt: Date.now(),
      data: draftData,
    };

    if (existingIndex >= 0) {
      // Update existing
      drafts[existingIndex] = draftEntry;
    } else {
      // It's fine if they already have 3 drafts because we block UI, but just in case:
      if (drafts.length >= MAX_DRAFTS) {
        throw new Error("Maximum number of drafts reached.");
      }
      drafts.push(draftEntry);
    }
    
    // Sort by most recently updated
    drafts.sort((a, b) => b.updatedAt - a.updatedAt);
    
    localStorage.setItem(`${STORAGE_PREFIX}${userId}`, JSON.stringify(drafts));
  } catch (e) {
    console.error("Error saving draft to localStorage", e);
  }
}

export function deleteDraft(userId, draftId) {
  if (!userId || !draftId) return;
  try {
    const drafts = getDrafts(userId);
    const filtered = drafts.filter((d) => d.id !== draftId);
    localStorage.setItem(`${STORAGE_PREFIX}${userId}`, JSON.stringify(filtered));
  } catch (e) {
    console.error("Error deleting draft from localStorage", e);
  }
}
